// extracted by mini-css-extract-plugin
module.exports = {"panel":"_ebad4f2","hasInfo":"_c86f53e","arrow":"_7ccf35a","blue":"_14524db","red":"_d76a2ba","info":"_4b30194","opened":"_c5f2da7"};